import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { ExternosService } from 'src/app/services/externos/externos.service';
import { MaestrasService } from 'src/app/services/maestra/maestras.service';

import { Cargo } from 'src/app/models/Cargo';
import { Denunciado } from 'src/app/models/Denunciado';
import { Persona } from 'src/app/models/Persona';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { TipoDocumento } from 'src/app/models/TipoDocumento';
import { ConvertirFlag, PERSONA_EXTERNA, PERSONA_MAESTRA, GetDate, iconError, getBooleanFlag, ngClassAceptarModal, ngClassSalirModal, isEmpty, isNotEmpty, dscEtiquetaBtnAcepModal, dscEtiquetaBtnSalirModal, ConvertDateTimeToStr3, ConvertDateTimeToStrForBD, GetDateTimeString, NumIdTipoDocDNI, NumIdTipoDocDesconocido, DscFuncInvPEDe, openModalMensajePrg } from 'src/app/general/variables';
import { openModalMensaje } from 'src/app/general/variables';
import { PersonaService } from 'src/app/services/persona.service';
import { NavModalComponent } from 'src/app/pages/General/nav-modal/nav-modal.component';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-modal-funcionario',
  templateUrl: './modal-funcionario.component.html',
  styleUrls: ['./modal-funcionario.component.css']
})

export class ModalFuncionarioComponent implements OnInit {

  // Icons
  iconoError = iconError;
  ngClassAceptarModal = ngClassAceptarModal;
  ngClassSalirModal = ngClassSalirModal;
  dscEtiquetaBtnAcepModal = dscEtiquetaBtnAcepModal;
  dscEtiquetaBtnSalirModal = dscEtiquetaBtnSalirModal;
  // strDscMask:string = "";

  //
  tipoDocumento: number = null ;
  personaBusqueda = new Persona();
  denunciado = new Denunciado();

  flgNroDocDisabled: boolean;
  flgTipoDocDisabled: boolean;
  flgApellidoPDisabled: boolean;
  flgApellidoMDisabled: boolean;
  flgNombresDisabled: boolean;
  flgCargoDisabled: boolean;
  DscFuncInvPEDe = DscFuncInvPEDe;

  //
  pApellidoError = 'Ingrese apellido paterno , el campo no acepeta números';
  sApellidoError = 'Ingrese apellido materno, el campo no acepta números';
  nombresError = 'Ingrese sus nombres completos, el campo no acepta números';
  cargoError = 'Seleccione un cargo';
  tipoDocumentoError = 'Seleccione un tipo de documento';
  strDscTitulo  = 'Funcionario(s) o Servidor(es) Público(s) Involucrado(s)';

  soloLetras = '^[A-Z ]+$'; // \s
  /// ^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g
  conoce_funcionario =  false;
  listTipoDoc: TipoDocumento[] = [];
  listCargo: Cargo[] = [];
  // flgPermaneceEntidad : boolean = false;
  strFlgPermEntidad: string = null;
  flgDeshabilitaValidar = false;
  flgModalEditar = false;

  @ViewChild(NavModalComponent) navModalC: NavModalComponent;


  formFuncionario = new FormGroup({

    flg_conoce_funcionario : new FormControl(''),
    input_sApellido : new FormControl('', [Validators.required, Validators.maxLength(32), Validators.pattern(this.soloLetras)]),

    input_pApellido : new FormControl('', [Validators.required, Validators.maxLength(32), Validators.pattern(this.soloLetras)]),
    input_nombresDenun : new FormControl('', [Validators.required, Validators.maxLength(32), Validators.pattern(this.soloLetras)]),
    select_tipoDoc : new FormControl(null, [Validators.required]),
    select_cargo : new FormControl('', [Validators.required]),
    input_nroDoc : new FormControl(''),
    flg_permanece_entidad : new FormControl('')
  });


  constructor(private maestra: MaestrasService, private externoService: ExternosService,
              public dialogRef: MatDialogRef<ModalFuncionarioComponent>, private personaService: PersonaService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private dialog: MatDialog,
              private spinner: NgxSpinnerService) {

  }

  get input_pApellido() {
    return this.formFuncionario.controls.input_pApellido;
  }

  get input_sApellido() {
    return this.formFuncionario.get('input_sApellido');
  }

  get flg_conoce_funcionario() {
    return this.formFuncionario.get('flg_conoce_funcionario');
  }


  get input_nombresDenun()  {

    return this.formFuncionario.get('input_nombresDenun');
  }

  get select_tipoDoc()  {
    return this.formFuncionario.get('select_tipoDoc');
  }

  get select_cargo()  {
    return this.formFuncionario.get('select_cargo');
  }
  get input_nroDoc()  {
    return this.formFuncionario.get('input_nroDoc');
  }

  get flg_permanece_entidad()  {

    return this.formFuncionario.get('flg_permanece_entidad');
  }

  ngOnInit() {

    let vFlgModalEditar = false;
    let vDenunciado = new Denunciado();

    this.navModalC.setDatosNavModal2(this.strDscTitulo);


    this.maestra.obtenerTipoDocumentoView().subscribe(data => {
      this.listTipoDoc = data;

      this.listTipoDoc.sort(function(a, b) {

        if (a.ctipdocumentoDsc > b.ctipdocumentoDsc) {
          return 1;
        }

        if (a.ctipdocumentoDsc < b.ctipdocumentoDsc) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });


    });

    this.maestra.obtenerCargoTipo('SI').subscribe(data => {
      this.listCargo = data;

    });

    if (this.data.numIndexEdit != null) {

      vDenunciado = this.data.listModalDenunciado[this.data.numIndexEdit];

      this._setDatosModalFunc(vDenunciado);

      vFlgModalEditar = true;

    } else {

      this.tipoDocumento = NumIdTipoDocDesconocido;

      this.cambioTipoDocumento();

    }

    this.flgModalEditar = vFlgModalEditar;

  }

  _cambioNroDoc() {

    this.denunciado.cdenunciadoNombres = null;
    this.denunciado.cdenunciadoApepaterno = null;
    this.denunciado.cdenunciadoApematerno = '';

  }

  cambiarConoceFuncionario(cbkFuncionario) {
    this.conoce_funcionario = cbkFuncionario.checked;
    this.cambioTipoDocumento();
  }

  // _cambioNroDoc()
  // {


  //   var vCantCadena = this.denunciado.cdenunciadoNrodoc.length;
  //   let tope:number = this.strDscMask.length;

  //   if(vCantCadena > tope)
  //   {

  //     this.denunciado.cdenunciadoNrodoc = this.denunciado.cdenunciadoNrodoc.substr(vCantCadena - tope);

  //   }


  // }

  agregarDenunciantes() {

    // console.log(this.personaBusqueda);

    const valido = true;
    let repetido = true;

    // let denunciado = new Denunciado();
    const tipoDoc = this.tipoDocumento; // this.formFuncionario.get('select_tipoDoc').value;
    let cargoV = new Cargo();
    // var idCargo = this.denunciado.cargo.ncargoId;//this.formFuncionario.get('select_cargo').value;
    const idCargo = this.denunciado.ndenunciadoIdcargo;
    const nroDoc = this.denunciado.cdenunciadoNrodoc; // this.formFuncionario.get('input_nroDoc').value;
    let nombresDenun = this.denunciado.cdenunciadoNombres; // this.formFuncionario.get('input_nombresDenun').value;
    let pApellidoDenun = this.denunciado.cdenunciadoApepaterno; // this.formFuncionario.get('input_pApellido').value;
    let mApellidoDenun = this.denunciado.cdenunciadoApematerno; // this.formFuncionario.get('input_sApellido').value;
    const vNumIndex = this.denunciado.numIndex;
    let vDscError = '';
    // let flgTieneNroDoc:boolean = (nroDoc.length > 0);
    let flgTieneNroDoc = false;

    // console.log("===mApellidoDenun",mApellidoDenun);

    mApellidoDenun = (mApellidoDenun ? mApellidoDenun : '');

    // console.log("===mApellidoDenun22",mApellidoDenun);

    if (nroDoc) {

      flgTieneNroDoc = (nroDoc.length > 0);

    }

    // console.log("=====tipoDoc",tipoDoc);

    if (tipoDoc == null) {

      vDscError = 'el tipo documento';

    } else if (isEmpty(nombresDenun)) {

      vDscError = 'los nombres';

    } else if (isEmpty(pApellidoDenun)) {

      vDscError = 'el primer apellido';

    }
    // else if(isEmpty(mApellidoDenun))
    // {

    //   vDscError = "el segundo apellido";

    // }
    // else if(idCargo == null)
    // {

    //   vDscError = "el cargo";

    // }

    if (isNotEmpty(vDscError)) {

      openModalMensaje(this.strDscTitulo, 'Ingrese ' + vDscError + ', por favor verifique', this.dialog);

      return;

    }

    if (this._getMaskTipoDoc().length != nroDoc.length && !this.flgNroDocDisabled) {

      openModalMensaje(this.strDscTitulo, 'la cantidad de digitos del número de documento es incorrecto, por favor verifique', this.dialog);

      return;


    }

    nombresDenun = nombresDenun.trim();
    pApellidoDenun = pApellidoDenun.trim();
    mApellidoDenun = mApellidoDenun.trim();


    this.denunciado.tipoDocumento.ntipdocumentoId = tipoDoc;

    // if(tipoDoc == 1)
    // if(flgTieneNroDoc && this.personaBusqueda)
    // {

    //   if(nroDoc != null)
    //   {

    //     if(nroDoc.length > 0) //
    //     {
    //       this.personaBusqueda.cpersonaNombres =  nombresDenun;
    //       this.personaBusqueda.cpersonaApepaterno = pApellidoDenun;
    //       this.personaBusqueda.cpersonaApematerno = mApellidoDenun;
    //       this.personaBusqueda.cpersonaNrodoc = nroDoc;
    //       //this.denunciado.ndenunciadoIdtipdoc = this.personaBusqueda.npersonaIdtipdoc;
    //       this.denunciado.ndenunciadoIdtipdoc = tipoDoc;
    //      // denunciado.cdenunciadoNrodoc = this.personaBusqueda.cpersonaNrodoc;
    //     }

    //   }
    //   else{

    //     valido = false;
    //   }
    // }else{
    //   this.personaBusqueda = null;
    // }

    this.personaBusqueda.cpersonaApepaterno = pApellidoDenun;
    this.personaBusqueda.cpersonaNrodoc = nroDoc;
    this.personaBusqueda.cpersonaApematerno = mApellidoDenun;
    this.personaBusqueda.cpersonaNombres = nombresDenun;
    this.personaBusqueda.npersonaIdtipdoc = tipoDoc;


    // console.log("==========this.personaBusqueda",this.personaBusqueda);

    this.denunciado.persona =  this.personaBusqueda;

    if (idCargo) {

      cargoV = this.obtenerCargo(idCargo);
      this.denunciado.cargo = cargoV;

    }

    this.denunciado.cdenunciadoFlgpermentidad = this.strFlgPermEntidad; // ConvertirFlag(this.flgPermaneceEntidad);
    this.denunciado.ndenunciadoIdcargo = idCargo;

    // console.log("===this.denunciado",this.denunciado);

    // console.log(cargoV);

    if (this.data.listModalDenunciado.length > 0) {
     // if(this.formFuncionario.get('select_tipoDoc').value == 1){
      // if(this.tipoDocumento == 1)
      if (flgTieneNroDoc) {

        this.data.listModalDenunciado.forEach((den, index) => {

          if (this._validaEditarIndex(index)) {return; }

          // if(den.ndenunciadoIdtipdoc == 1)

          if (den.persona) {

            if (den.persona.cpersonaNrodoc.length > 0) {

              if (den.persona.cpersonaNrodoc == this.denunciado.persona.cpersonaNrodoc && den.persona.npersonaIdtipdoc == this.denunciado.persona.npersonaIdtipdoc) {

                repetido = false;

              }

            }

          }

        });

      } else {

        this.data.listModalDenunciado.forEach((den, index) => {

          if (this._validaEditarIndex(index)) {return; }

          // console.log("==============den");
          // console.log(den);

          // console.log("==============this.denunciado");
          // console.log(this.denunciado);

          if (den.cdenunciadoNombres.toUpperCase().trim() == this.denunciado.cdenunciadoNombres.toUpperCase().trim() &&
            den.cdenunciadoApepaterno.toUpperCase().trim() == this.denunciado.cdenunciadoApepaterno.toUpperCase().trim() &&
            den.cdenunciadoApematerno.toUpperCase().trim() == this.denunciado.cdenunciadoApematerno.toUpperCase().trim()) {
              repetido = false;

          }

        });

      }

      // if(this.denunciado.cargo == null || this.denunciado.cargo.ncargoId == null)
      // {
      //     valido = false;
      // }
    }



    // Se debe validar de la otra forma (falta implementar) if(this.formFuncionario.valid){

      // console.log("=============listadoffinal1");

    if (valido && repetido) {

      // console.log("=============listadoffina2");

      if (vNumIndex != null) {

        this.data.listModalDenunciado.splice(vNumIndex, 1);

      }

      this.data.listModalDenunciado.push(this.denunciado);

      this.data.listModalDenunciado.forEach((element, index) => {

        element.numIndex = index;

      });

      // console.log("====this.data.listModalDenunciado",this.data.listModalDenunciado);

      this.dialogRef.close({listModalDenunciado: this.data.listModalDenunciado, cbkConoce: false});
      // console.log("=============listadoffina4");
    } else {

      if (!valido) {

        openModalMensaje('Funcionario', 'Existen campos vacios', this.dialog);
      }

      if (!repetido) {
        openModalMensaje('Funcionario', 'El funcionario ya se encuentra registrado', this.dialog);
      }


    }

    /*}else{

      openModalMensaje('Funcionario','Existen campos vacios',this.dialog);

    }*/


}

_mayusculas(e, numCaso: number) {

  let vData = '';
  const re = /^[A-Za-z, ,á-ü,Á-Ü]+$/;
  // let re = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g;
  let valor = '';

  for (let index = 0; index < e.target.value.length; index++) {

    const element = e.target.value.substr(index, 1);

    if (re.test(element) == true) {

      valor = valor + element;

    }

  }

  e.target.value = valor.toUpperCase();

  // if(re.test(e.target.value) == false)
  // {

  //   e.target.value = e.target.value.substr(0,e.target.value.length - 1);

  // }else{

  //   e.target.value = e.target.value.toUpperCase();

  // }

  // console.log(e);


  vData = e.target.value; // .trim();

  e.target.value = vData;

  switch (numCaso) {
    case 1:

      this.denunciado.cdenunciadoApepaterno = vData;

      break;

    case 2:

      this.denunciado.cdenunciadoApematerno = vData;

      break;

    case 3:

      this.denunciado.cdenunciadoNombres = vData;

      break;

    default:
      break;
  }

 }

_validaEditarIndex(indexBucle: number) {

  let vFlgError = false;

  if (this.flgModalEditar && indexBucle == this.data.numIndexEdit) {

    vFlgError = true;

  }

  return vFlgError;

}

// CambioCheckPerm(flgEvent){
//   this.flgPermaneceEntidad = flgEvent.checked;
// }

cancelar() {
  // this.dialogRef.close({listDenunciado:this.data.listDenunciado,cbkConoce:false});
  this.dialogRef.close();
}

obtenerCargo(idCargo: number) {
    let cargo = new Cargo();
    this.listCargo.forEach(item => {
        if (idCargo == item.ncargoId) {
            cargo = item;
        }
    });
    return cargo;
}

llenarPersonaBusqueda(dataPersona, tipoDocumento, tipoServicio) {

  this.personaBusqueda.npersonaIdtipdoc = tipoDocumento;

  // console.log("======tipoServicio",tipoServicio);

  if (tipoServicio == 1) {

    const dcBornDate: string = GetDateTimeString(ConvertDateTimeToStr3(dataPersona.dcBornDate.trim()));
    const dcExpeditionDate: string = GetDateTimeString(ConvertDateTimeToStr3(dataPersona.dcExpeditionDate.trim()));

    this.personaBusqueda.cpersonaNombres = dataPersona.dcFirstName.trim(); // .trim();

    this.personaBusqueda.cpersonaApepaterno = dataPersona.dcLastName1.trim();
    this.personaBusqueda.cpersonaApematerno = dataPersona.dcLastName2.trim();
    this.personaBusqueda.cpersonaDscdireccion = dataPersona.dcAddress.trim();

    this.personaBusqueda.cpersonaPrinommater = dataPersona.dcMotherName.trim(); // .trim();
    this.personaBusqueda.cpersonaCdepartdomic = dataPersona.dcAddDepUbigCode.trim();
    this.personaBusqueda.cpersonaCprovdomic = dataPersona.dcAddProvUbigCode.trim();
    this.personaBusqueda.cpersonaCdistdomic = dataPersona.dcAddDistUbigCode.trim();

    this.personaBusqueda.strDpersonaFemidoc = dcExpeditionDate;
    this.personaBusqueda.strDpersonaFnacimiento = dcBornDate;

    this.personaBusqueda.cpersonaCodsexo = dataPersona.dcGenter;

    this.personaBusqueda.cpersonaNrodoc = dataPersona.dcDocument;

    this.denunciado.cdenunciadoNombres = dataPersona.dcFirstName;
    this.denunciado.cdenunciadoApepaterno = dataPersona.dcLastName1;
    this.denunciado.cdenunciadoApematerno = dataPersona.dcLastName2;

  } else {

    // this.personaBusqueda.cpersonaNrodoc = dataPersona.cpersonaNrodoc;
    // this.personaBusqueda.npersonaId = dataPersona.npersonaId;

    this.personaBusqueda = dataPersona;

    this.denunciado.cdenunciadoNombres = dataPersona.cpersonaNombres;
    this.denunciado.cdenunciadoApepaterno = dataPersona.cpersonaApepaterno;
    this.denunciado.cdenunciadoApematerno = dataPersona.cpersonaApematerno;

  }

}

  obtenerPersonaXNumeroDocumento() {

    const dni =  this.denunciado.cdenunciadoNrodoc; // this.formFuncionario.get('input_nroDoc').value;
    const tipoDoc =  String(this.tipoDocumento); // this.formFuncionario.get('select_tipoDoc').value;


    if (dni != null) {

      if (dni.length == 8) {


        this.flgDeshabilitaValidar = true;

        this.spinner.show();

        this.personaService.obtenerPersona(tipoDoc, dni).subscribe(personaMa => {

          const resultadoMa: Persona = JSON.parse(JSON.stringify(personaMa));

          this.spinner.hide();

          if (resultadoMa == null) {

              this.spinner.show();

              this.externoService.obtenerPersonaXDniReniec(dni).subscribe(data => {

                  const resultado = JSON.parse(JSON.stringify(data));

                  this.spinner.hide();

                  this.llenarPersonaBusqueda(resultado, tipoDoc, PERSONA_EXTERNA);

                  this.flgDeshabilitaValidar = false;

              }, error => {

                  console.log(error);

                  this.spinner.hide();

                  this._validaDNI();



              });
            } else {

              if (resultadoMa.cpersonaNombres == null || resultadoMa.cpersonaApepaterno == null || resultadoMa.cpersonaApematerno == null) {

                this.spinner.show();

                this.externoService.obtenerPersonaXDniReniec(dni).subscribe(data => {

                  const resultado = JSON.parse(JSON.stringify(data));

                  this.spinner.hide();

                  this.llenarPersonaBusqueda(resultado, tipoDoc, PERSONA_EXTERNA);

                  this.flgDeshabilitaValidar = false;
                }, error => {

                  console.log(error);

                  this.spinner.hide();

                  this._validaDNI();



              });
              } else {
                this.llenarPersonaBusqueda(resultadoMa, tipoDoc, PERSONA_MAESTRA);
                this.flgDeshabilitaValidar = false;
              }
            }
        }, error => {

            console.log(error);

            this.spinner.hide();

            this._validaDNI();

        });

        // openModalMensajePrg("","",this.dialog,true).subscribe(result=>{

        //   if(result == false)
        //   {


        //   }

        // });

      } else {
        this._validaDNI();

      }

    }


  }

  _validaDNI() {

      openModalMensaje('Funcionario', 'Debe ingresar un DNI válido', this.dialog);
      this.flgDeshabilitaValidar = false;


  }

  _setDatosModalFunc(denunciado: Denunciado) {

    this.denunciado = new Denunciado();

    // this.denunciado.flgEditar = flgEditar;

    // console.log("=============0denunciado");
    // console.log(denunciado);

    this.tipoDocumento = denunciado.tipoDocumento.ntipdocumentoId;

    this.cambioTipoDocumento();

    this.denunciado = denunciado;

    // this.flgPermaneceEntidad = getBooleanFlag(denunciado.cdenunciadoFlgpermentidad);
    this.strFlgPermEntidad = denunciado.cdenunciadoFlgpermentidad;

  }

  cambioTipoDocumento() {


    // if(this.tipoDocumento == NumIdTipoDocDNI)
    // {

    //   this.flgApellidoPDisabled = true;
    //   this.flgApellidoMDisabled = true;
    //   this.flgNombresDisabled = true;
    //   this.flgNroDocDisabled = false;

    // }else
    // {

    //   this.flgApellidoPDisabled = false;
    //   this.flgApellidoMDisabled = false;
    //   this.flgNombresDisabled = false;
    //   this.flgNroDocDisabled = (this.tipoDocumento == NumIdTipoDocDesconocido);

    // }

    this.flgApellidoPDisabled = false;
    this.flgApellidoMDisabled = false;
    this.flgNombresDisabled = false;
    this.flgNroDocDisabled = (this.tipoDocumento == NumIdTipoDocDesconocido);

    this.denunciado.cdenunciadoApepaterno = '';
    this.denunciado.cdenunciadoApematerno = '';
    this.denunciado.cdenunciadoNombres = '';
    this.denunciado.cargo.ncargoId = null;

    this.denunciado.cdenunciadoNrodoc = '';

    // this.strDscMask = this._getMaskTipoDoc();

    // console.log("this.denunciado.cdenunciadoNrodoc",this.denunciado.cdenunciadoNrodoc) ;



  }

  _getMaskTipoDoc() {

    const vIdTipDoc: number = this.tipoDocumento;
    const vItem = this.listTipoDoc.find(x => x.ntipdocumentoId == vIdTipDoc);
    let vDscReturn = '';

    if (vItem != null) {

      vDscReturn = vItem.ctipdocumentoMask;

    }

    return vDscReturn;

  }


}
